export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setOrdersToChangeStatus(state, ordersToChangeStatus) {
    state.ordersToChangeStatus = ordersToChangeStatus;
  },
  setOrdersSelected(state, ordersSelected) {
    state.ordersSelected = ordersSelected;
  },
  setFilters(state, filters) {
    state.filters = filters;
  },
  setShipperEvents(state, shipperEvents) {
    state.shipperEvents = shipperEvents;
  },
  setFiles(state, payload) {
    state.files = payload;
  },
  setFilesCount(state, payload) {
    state.filesCount = payload;
  },
  setCurrentPage(state, payload) {
    state.currentPage = payload;
  },
  setPerPage(state, payload) {
    state.perPage = payload;
  },
  setLogs(state, payload) {
    state.logs = payload;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/change-order/store/mutations.js